module.exports = __webpack_public_path__ + "static/media/6evancalebintro.e49fbf50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6evancalebintro.png
// module id = 105
// module chunks = 0